window.bars.listener.ready.push(function() {
	//Level Click
	var respMenuParentItems = $(".js--responsive-menu-parent");
	respMenuParentItems.on("click", function(e) {
		e.stopPropagation();
		var _this = $(this);
		_this.addClass("nav-toggle__item--parent--child-open");
	});

	//Level Back-click
	var respMenuBackButtons = $(".js--nav-toggle_item_child-page__back");
	respMenuBackButtons.on("click", function(e) {
		e.stopPropagation()
		var _this = $(this);
		var parentLevel = _this.closest(".js--responsive-menu-parent");
		parentLevel.removeClass("nav-toggle__item--parent--child-open");
	});
});

window.bars.listener.ready.push(function(){
	$(".megamenu-parent").on("click", function(e) {
		var _this = $(this);
		var _clickTarget = $(e.target);
		if(_clickTarget[0].tagName === "A" && _clickTarget.parent()[0] !== _this[0]) {
			_this.removeClass("megamenu-parent--open");
		}
		else {
			if(_clickTarget.hasClass("megamenu") && _this.hasClass("megamenu-parent--open") ||
					(_clickTarget.hasClass("megamenu-parent") || _clickTarget.parent().hasClass("megamenu-parent")) && _this.hasClass("megamenu-parent--open")) {
				_this.removeClass("megamenu-parent--open");
			}
			else if(_clickTarget.hasClass("megamenu-parent") || _clickTarget.parent().hasClass("megamenu-parent")) {
				$(".megamenu-parent").removeClass("megamenu-parent--open");
				_this.addClass("megamenu-parent--open");
			}
		}
	});
});


/**
 * hide/show navbar-meta on scroll
 **/

window.bars.listener.ready.push(function(){

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('.navbar--meta').outerHeight();

	$(window).scroll(function (event) {
		didScroll = true;
	});

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = $(this).scrollTop();

		if (Math.abs(lastScrollTop - st) <= delta)
			return;


		if (st > lastScrollTop && st > navbarHeight) {
			// Scroll Down
			$('header').removeClass('js-scroll-up').addClass('js-scroll-down');
		} else {
			// Scroll Up
			if (st + $(window).height() < $(document).height()) {
				$('header').removeClass('js-scroll-down').addClass('js-scroll-up');
			}
		}

		lastScrollTop = st;
	}

});

window.bars.listener.ready.push(function() {

	var dropInput = document.getElementById("c_forms_drag-input");
	var dropContainer = document.getElementById("c_forms_drag-container");
	if(dropInput && dropContainer) {
		var files = [];
		var fillTags = function() {
			var tagContainer = $(dropContainer).parent().find(".c_forms_file-tags");
			tagContainer.empty();
			for(var i = 0; i < dropInput.files.length; i++) {
				(function(_i) {
					var tag = $("<div class='c_forms_file-tag'>"+dropInput.files[_i].name+"</div>");
					tag.on("click", function() {
						var newList = Array.from(dropInput.files);
						newList.splice(_i, 1);
						var dt = new DataTransfer()
						for (var j = 0; j < newList.length; j++) {
							dt.items.add(newList[j]);
						}
						dropInput.files = dt.files;
						fillTags();
					});
					tagContainer.append(tag);
				})(i);
			}

		}

		$(dropInput).on("change", function() {
			fillTags();
		});



		dropContainer.ondragover = dropContainer.ondragenter = function(evt) {
			evt.preventDefault();
		};

		dropContainer.ondrop = function(evt) {
			// pretty simple -- but not for IE :(
			files = evt.dataTransfer.files;
			dropInput.files = files;
			fillTags();

			// If you want to use some of the dropped files
			/*
			const dT = new DataTransfer();
			dT.items.add(evt.dataTransfer.files[0]);
			dT.items.add(evt.dataTransfer.files[3]);
			dropInput.files = dT.files;
			*/
			evt.preventDefault();
		};
	}

});


/*------------------------------------
			PROJECT JS
------------------------------------*/



$('.m-hotspots .js-modal__trigger').click(function(e){
   		
	var triggerId = $(this).next('modal').data('id');
	
	$(this).next('.modal').fadeIn('fast');
	$(this).css('display', 'flex');
	$('body').css('overflow', 'hidden');
		
	e.stopPropagation();
	
	$('.modal-hotspots .modal').click(function(e){
		
		$(this).fadeOut('slow');
		$(this).css('display', 'none');
		$('body').css('overflow', 'auto');
   	}) 
		
	$('.js-close-modal').click(function(){
			
		$(this).fadeOut('slow');
		$(this).css('display', 'none');
   		$('body').css('overflow', 'auto');
   	}) 
   		
});




// Read mor text

		
$('.text-collapse').hide();
$(".text-collapse").after( '<div class="js-trigger--collapse"><span></span><span>Mehr lesen</span></div>' );
	
$('.js-trigger--collapse').on('click', function() {

	$(this).prev('.text-collapse').slideToggle('fast');
	$(this).toggleClass('js-active');
});





// Milesstones
$('#milestones .btn').click(function(){
	$('#milestones .milestones-intro').fadeOut(20);
	$('#milestones .milestones-item').first().fadeIn(200);
	$('#milestones .milestones-item').first().css("display", "grid");
	$('#milestones .milestones-nav__dots').first().addClass('js-active');
});

var currentActiveMilestone = 0;
function setMilestone(dataid) {
	setMilestoneDots(dataid);
	$('.milestones-item').each(function(){
		if ($(this).data('id') == dataid){
			$(this).fadeIn(200);
			$(this).css("display", "grid");
		} else {
			$(this).fadeOut(0);
		}
	});
	currentActiveMilestone = dataid;

	var _milestoneItems = $(".milestones-item");
	if(currentActiveMilestone <= 0) {
		$(".milestones-content__arrow--prev").fadeOut(200);
	}
	else {
		$(".milestones-content__arrow--prev").fadeIn(200);
	}

	if(currentActiveMilestone >= _milestoneItems.length-1) {
		$(".milestones-content__arrow--next").fadeOut(200);
	}
	else {
		$(".milestones-content__arrow--next").fadeIn(200);
	}
}
function setMilestoneDots(dataid) {
	var milestoneDots = $('#milestones .milestones-nav__dots');
	milestoneDots.removeClass('js-active');
	milestoneDots.eq(dataid).addClass('js-active');
}

$('#milestones .milestones-nav__dots').click(function(){
	
	var dataid = $(this).data('id');
	$('#milestones .milestones-intro').fadeOut(0);
	setMilestone(dataid);
});



$('#milestones .milestones-content__arrow').click(function(){
	var _milestoneItems = $(".milestones-item");
	var _this = $(this);
	var _index = currentActiveMilestone;
	if(_this.hasClass("milestones-content__arrow--prev")) {
		if(_index > 0) {
			setMilestone(_index - 1);
		}
	}
	else {
		if(_index < _milestoneItems.length-1) {
			setMilestone(_index + 1);
		}
	}
});







// Tabs

$('.tabs').each(function () {
	
	var $this = $(this);
	
	$this.find('ul.tab-control li').first().addClass('js-active');
	$this.find('.tab-content').first().css("display", "block");
	
	
	$this.find('ul.tab-control li').click(function(){
		
		var dataid = $(this).data('id');
		
		$this.find('ul.tab-control li').removeClass('js-active');
	
		
		if ($(this).hasClass('js-active')) {
			
			$(this).removeClass('js-active');
		
		} else {
		
			$(this).addClass('js-active');
		
		}
		
		$this.find('.tab-content').each(function(){
			
			if ($(this).data('id') == dataid){
				
				$(this).fadeIn(0);
				$(this).first().css("display", "block");
				
			} else {
				
				$(this).fadeOut(0);
			}
		});
	});
});






// Locations

$('.m-locations').each(function () {
	
	var $this = $(this);
	
	$this.find('ul.js-trigger li').first().addClass('js-active');
	$this.find('figure').first().css("display", "block");
	$this.find('.m-locations__text').first().css("display", "block");
	
	
	$this.find('ul.js-trigger li').click(function(){
		
		
		var dataid = $(this).data('id');
		
		$this.find('ul.js-trigger li').removeClass('js-active');
	
		
		if ($(this).hasClass('js-active')) {
			
			$(this).removeClass('js-active');
		
		} else {
		
			$(this).addClass('js-active');
		
		}
		
		$this.find('figure').each(function(){
			
			if ($(this).data('id') == dataid){
				
				$(this).fadeIn(200);
				$(this).first().css("display", "block");
				
			} else {
				
				$(this).fadeOut(0);
			}
		});
		
		$this.find('.m-locations__text').each(function(){
			
			if ($(this).data('id') == dataid){
				
				$(this).fadeIn(150);
				$(this).first().css("display", "block");
				
			} else {
				
				$(this).fadeOut(0);
			}
		});
	});
});







// Modal

$('.js-singleflex-trigger').addClass('js-active');
$('.modal-twinflex').css("display", "none");
$('g#twinflex').css("display", "none");
$('.text-singleflex').css("display", "block");

$('.js-singleflex-trigger').click(function(e){
	
	
	$(this).addClass('js-active');
	$('.js-twinflex-trigger').removeClass('js-active');
	
	$('.modal-twinflex').fadeOut();	
	$('.modal-singleflex').fadeIn();
	$('g#twinflex').fadeOut();
	$('g#singleflex').fadeIn();
	
	
	$('.text-multiflex').fadeOut();
	
	setTimeout(function(){
		$('.text-singleflex').fadeIn();
	}, 400);
	
});

$('.js-twinflex-trigger').click(function(e){
	
	
	$(this).addClass('js-active');
	$('.js-singleflex-trigger').removeClass('js-active');

	$('.modal-singleflex').fadeOut();
	$('.modal-twinflex').fadeIn();
	$('g#singleflex').fadeOut();
	$('g#twinflex').fadeIn();
	
	
	$('.text-singleflex').fadeOut();
	
	setTimeout(function(){
		$('.text-multiflex').fadeIn();
	}, 400);

});






// downloads filter

$('.filter-products-results').find('li').css("display", "none");

var subcategoryArray = [];
$('.filter-products li:not(:first-child)').click(function(){

	var dataId = $(this).data('product');

	$('.filter-products li').removeClass('js-active');

	if ($(this).hasClass('js-active')) {
		
		$(this).removeClass('js-active');
	
	} else {
	
		$(this).addClass('js-active');
	}
	
			
	// show results
			
	$('.filter-products-results').find('li').each(function(){
		console.log(dataId);

		if(subcategoryArray.indexOf($(this).data('title')) == -1) {
			subcategoryArray.push($(this).data('title'));
		}
		if ($(this).data('product') == dataId){
							
			$(this).fadeIn(300);
			$(this).addClass('js-active');
			
		} else {
							
			$(this).fadeOut(0);
			$(this).removeClass('js-active');
		}
	});
	
	
	
	// show product results
	
	$('#download-results').find('.download-results_category').each(function(){
								
		if ($(this).data('category') == dataId){
							
			$(this).fadeIn(300);
			
		} else {
							
			$(this).fadeOut(0);
		}
	});
	
}); 


// remove product from filter


$('.filter-products-results li').click(function(){

	var dataTitle = $(this).data('title');

	if ($(this).hasClass('js-active')) {
		var _index = subcategoryArray.indexOf(dataTitle);
		if (_index > -1) {
			subcategoryArray.splice(_index, 1);
		}
		$(this).removeClass('js-active');
		$(this).fadeOut(0);
		
	} else {
		//$(this).addClass('js-active');
	}
	
	console.log(dataTitle);
	if(subcategoryArray.length > 0) {
		$('#download-results').find('article').each(function(){

			if (subcategoryArray.indexOf($(this).data('title')) == -1){

				$(this).fadeOut(0);

			} else {
				//$(this).fadeIn(0);
			}
		});
	}
	else {
		$('#download-results').find('article').each(function(){
			$(this).fadeIn(0);
		});
	}


}); 







// @monti: Funktioniert noch nicht :-( Hier wollte ich checken ob die Auswahl Teil des Arrays ist und wenn TRUE ausblenden. Geht um die Checkboxen oben.


var categoryArray = [];
var dataName = " ";

$('.filter-category li input').change(function() {
	
	var dataName = $(this).attr("name");
	
	// Build array/index
    let index = categoryArray.indexOf(dataName);
	
    if (index >= 0) {
        categoryArray.splice(index, 1);
    } else {
        categoryArray.push(dataName);			
    }

	//alert(categoryArray);
	

	$('#download-results').find('.article-table__row').each(function(){

		var found = false;
		var dataCategory = $(this).data('category').split(",");
		console.log(categoryArray);

		if(categoryArray.length > 0) {
			// Loop each class the element has
			for (var i = 0; i < dataCategory.length; i++) {
				// Check if each class from the element is within the array of classes we want to match
				if (categoryArray.indexOf(dataCategory[i]) !== -1) {
					// We found a match, break out of the loop
					found = true;
					break;
				}
			}

			// check if found or not
			if (!found) {
				$(this).fadeOut(0);

			} else {
				$(this).fadeIn(0);
			}
		}
		else {
			$(this).fadeIn(0);
		}

					
	});
			
});


	






// Fix header on scroll

$(window).scroll(function() { 
	
    var scroll = $(window).scrollTop();
	
	if (scroll >= 100) {
	
		$("header").addClass('js-shrink');
    }
	
	else {
	  
		$("header").removeClass('js-shrink');
	  
	}
}); 



// smooth scroll

if ( window.location.hash ) scroll(0,0);
setTimeout( function() { scroll(0,0); }, 4);

$(function() {

   	// your current click function
   	$('a[href*="#"]:not([href="#"])').click(function () {
		
		
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            
			if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top + -50
                }, 1000);
                return false;
            }
        }
   	});

   // *only* if we have anchor on the url
   if(window.location.hash) {

       	// smooth scroll to the anchor id
       	$('html, body').animate({
           scrollTop: $(window.location.hash).offset().top + -50
       	}, 1000, 'swing');
	  
   }

});






// Isotope


// init Isotope
var $grid = $('.isotope-news').isotope({
	
	itemSelector: '.isotope-news__item',
	layoutMode: 'fitRows',
	getSortData: {
		category: '[data-category]',
	}
});

// filter functions
var filterFns = {
};

// bind filter button click
$('.isotope-news-filter').on( 'click', 'li', function() {
	
	var filterValue = $(this).attr('data-filter');
	
	// use filterFn if matches value
  	filterValue = filterFns[ filterValue ] || filterValue;
  	$grid.isotope({ filter: filterValue });
});

// change is-checked class on buttons
$('.isotope-news-filter li').each( function( i, buttonGroup ) {
	
	var $buttonGroup = $( buttonGroup );
	
	$buttonGroup.on( 'click', 'li', function() {
		$buttonGroup.find('.js-active').removeClass('js-active');
		$( this ).addClass('js-active');
	});
});



$('.isotope-news-filter li').click(function(){
	
	$('.isotope-news-filter li').removeClass('js-active');

	if ($(this).hasClass('js-active')) {
		
		$(this).removeClass('js-active');
	
	} else {
	
		$(this).addClass('js-active');
	}
});





// Karriere > Jobs Datatables

$('#table-jobs').DataTable( {
    paging: false,
	searching: false,
	ordering: true
} );







// Slick

$('.slick-slider--hero').slick({
    infinite: true,
	autoplay: false,
	autoplaySpeed: 10000,
	rows:0,
	slidesToShow: 1,
	centerMode: false,
    centerPadding: '0px',
	slide:'.slide',
	initialSlide: 0,
	arrows: false,
    dots: true,
});


$('.slick-slider--images').slick({
    infinite: true,
	autoplay: true,
	autoplaySpeed: 6000,
	rows:0,
	slidesToShow: 1,
	centerMode: false,
    centerPadding: '0px',
	adaptiveHeight: true,
	slide:'.slide',
	initialSlide: 0,
	arrows: false,
    dots: true,
	responsive: [
	    {
			breakpoint: 900,
			settings: {
				slidesToShow: 1,
			}
	    }
	]
});



$('.slick-slider--aktuelles').slick({
    infinite: false,
	autoplay: true,
	autoplaySpeed: 10000,
	rows:0,
	slidesToShow: 3,
	centerMode: false,
    centerPadding: '0px',
	slide:'.slide',
	initialSlide: 0,
	arrows: true,
	nextArrow: '<span class="slick-next"></span>',
	prevArrow: '<span class="slick-prev"></span>',
    dots: false,
	responsive: [
	    {
			breakpoint: 900,
			settings: {
				slidesToShow: 1,
				dots: true
			}
	    }
	]
});








